import React from "react"
import PropTypes from "prop-types"

const ProvidersWindowCard = ({ prov, duracion, onChange }) => (
  <div className="cfg-card cfg-prov cfg-anim">
    <div className="cfg-prov-title">
      <div className="cfg-prov-icon color-primary">
        <i className="bx bx-package" />
      </div>
      <div>
        <div style={{ fontSize: "14px", fontWeight: 700 }}>
          Ventana de proveedores
        </div>
        <div style={{ fontSize: "12.5px", color: "#6b7280" }}>
          Aplica a todos los proveedores por igual
        </div>
      </div>
    </div>

    <div className="cfg-prov-fields">
      <span className="cfg-label">DE</span>
      <input
        type="time"
        className="cfg-input cfg-input-time"
        value={prov.start}
        onChange={event => onChange("start", event.target.value)}
      />
      <span className="cfg-label">A</span>
      <input
        type="time"
        className="cfg-input cfg-input-time"
        value={prov.end}
        onChange={event => onChange("end", event.target.value)}
      />
      <span className="cfg-prov-badge">{duracion}</span>
    </div>
  </div>
)

ProvidersWindowCard.propTypes = {
  prov: PropTypes.object.isRequired,
  duracion: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default ProvidersWindowCard
